import { BargainUserInfo } from '../../../../types'
import CharacterCounter from '../../../ui/CharacterCounter'
import { colors } from '@/components/MessageBoard/colors'

interface UserInfoDisplayProps {
  bargain_user_info: BargainUserInfo
  posterName: string
  onPosterNameChange?: (value: string) => void
  labelWidth?: number
}

const MAX_LENGTH = 10

const getStyles = (labelWidth: number): Record<string, React.CSSProperties> => ({
  formGroup: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    fontWeight: 'bold',
    fontSize: '14px',
    marginBottom: '4px',
    pointerEvents: 'none',
    width: `${labelWidth}px`,
    flexShrink: 0,
    marginRight: '8px',
  },
  userIcon: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    overflow: 'hidden',
    backgroundColor: '#f1f1f1',
  },
  userIconImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  userNameContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    margin: '12px 0 0',
  },
  userName: {
    fontWeight: '300',
    fontSize: '16px',
    color: colors['text-secondary'],
  },
  required: {
    color: '#e74c3c',
    marginLeft: '4px',
  },
  inputContainer: {
    flex: 1,
    position: 'relative',
  },
  input: {
    width: '100%',
    padding: '10px',
    fontSize: '16px',
    border: '1px solid #ddd',
    borderRadius: '4px',
  },
  counter: {
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
  },
})

const UserInfoDisplay: React.FC<UserInfoDisplayProps> = ({
  bargain_user_info,
  posterName,
  onPosterNameChange,
  labelWidth = 80,
}) => {
  const styles = getStyles(labelWidth)

  const getUserName = () => {
    if (bargain_user_info.type === 'tokubai_user') {
      return bargain_user_info.name || 'ユーザー名未設定'
    }
    return null
  }

  return (
    <div style={styles.formGroup}>
      <label style={styles.label}>
        ニック
        <br />
        ネーム<span style={styles.required}>*</span>
      </label>
      { getUserName() ? (
        <div style={styles.userNameContainer}>
          <div style={styles.userName}>{getUserName()}</div>
        </div>
        ) : (
        <div style={styles.inputContainer}>
          <input
            type="text"
            value={posterName}
            onChange={(e) => {
              const newValue = e.target.value
              if (newValue.length <= MAX_LENGTH) {
                onPosterNameChange(newValue)
              }
            }}
            placeholder="ニックネームを入力"
            style={styles.input}
            maxLength={MAX_LENGTH}
            required
          />
          <div style={styles.counter}>
            <CharacterCounter currentLength={posterName.length} maxLength={MAX_LENGTH} />
          </div>
        </div>
        )
      }
    </div>
  )
}

export default UserInfoDisplay
